import React, { Component } from 'react'
import { EventFormWrapper } from '~/styles'
import { Icon } from 'antd'

class Success extends Component {
  render () {
    return <EventFormWrapper className="EventRegisterPage">
      <div className="innerEventRegisterPage">
        <div className="dividedBox">
          <h1>
            <Icon type="check-circle" style={{color: 'rgb(82, 196, 26)'}} theme="twoTone" twoToneColor="#52c41a" />{` `}
            ส่งแบบฟอร์มเปิดงานสำเร็จ
          </h1>
          <span>
            ฝ่าย Sales จะติดต่อกลับหาท่านในวันทำการ ภายใน 48 ชั้่วโมง
          </span>
        </div>
      </div>
    </EventFormWrapper>
  }
}

export default Success



// WEBPACK FOOTER //
// ./src/App/pages/EventForm/Success.js